import React, { useState } from 'react';
import { Button, Card, CardBody, Form } from "reactstrap";
import { useFormik } from 'formik';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { RESET_PASSWORD_API } from '../../constants/Configs';
import InputField from '../../components/InputField';
import { handleError, handleSuccess } from '../../utils/toast';
import { resetPasswordValidationSchema } from '../../constants/Schemas';
import API from '../../services/api';
import { API_REQUEST, } from '../../constants/General';
import Loader from '../../components/Loader';
import { trimObjectValues } from '../../services/middleware';
import logo from '../../assets/images/logo-white.svg';

export default function ResetPassword() {
  // State
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location?.search.split("=");

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: resetPasswordValidationSchema,
    onSubmit: (values, { resetForm }) => {
      trimObjectValues(values)
      resetPassword({
        token: pathName[1],
        password: values.password
      }, resetForm)
    }
  });

  const resetPassword = (payload, resetForm) => {
    setLoading(true)
    API(API_REQUEST.post, RESET_PASSWORD_API, payload)
      .then((res) => {
        handleSuccess(res)
        resetForm({ values: '' });
        setLoading(false)
        navigate('/login');
      })
      .catch((error) => {
        handleError(error)
        setLoading(false)
      })
  }

  return (
    <div className="pre-login-section">
      <div className="pre-login-wrap">
        <div className="logo-wrap">
          <span><img src={logo} alt="logo" /></span>
        </div>
        <Card className="shadow">
          {loading && <Loader />}
          <CardBody>
            <div className="mb-4">
              <h1>Reset Password</h1>
            </div>
            <Form role="form">
              <InputField passwordField placeholder="New Password" fieldName="password" inputType={showNewPassword ? "text" : "password"} passwordIcon formik={formik} showPassword={showNewPassword} setShowPassword={setShowNewPassword} />
              <InputField passwordField placeholder="Confirm Password" fieldName="confirmPassword" inputType={showConfirmPassword ? "text" : "password"} passwordIcon formik={formik} showPassword={showConfirmPassword} setShowPassword={setShowConfirmPassword} />
              <div className="btn-wrap">
                <Button color='primary' disabled={!!Object.values(formik.errors)?.length} type="button" onClick={formik.handleSubmit} >
                  Reset
                </Button>
              </div>
            </Form>
            <div className="links-wrap">
              <Link className="secondary-link" to="/register">
                Create new account
              </Link>
              <Link className="secondary-link" to="/login">
                Already have an account?
              </Link>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
